export default __webpack_public_path__ + "static/media/image1b.e3f2e11c.png";